import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Phone: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.73328 1.9526C2.85518 2.17887 1.31728 2.37219 1.31572 2.38218C1.3043 2.45552 1.37248 3.59279 1.41681 4.06801C1.6876 6.97098 2.58998 9.8415 4.0074 12.3088C5.11216 14.2319 6.46159 15.9118 8.076 17.3739C11.3763 20.3628 15.5152 22.1854 19.932 22.595C20.4083 22.6391 21.6244 22.7117 21.6392 22.6968C21.6551 22.6809 22.4886 15.7126 22.4761 15.7001C22.4654 15.6894 14.5199 13.416 14.4931 13.416C14.4848 13.416 13.8962 14.393 13.185 15.5871C12.4739 16.7812 11.8838 17.7586 11.8738 17.7591C11.8491 17.7603 11.2387 17.346 10.911 17.1054C9.19142 15.8433 7.63605 14.2192 6.44836 12.4458L6.24062 12.1356L7.56631 11.3444C10.1488 9.80303 10.596 9.53243 10.5936 9.51231C10.5923 9.50115 10.0804 7.70192 9.45616 5.51401L8.32113 1.53601L8.23456 1.5386C8.18695 1.54002 6.61137 1.72633 4.73328 1.9526ZM5.11255 3.92814C4.19544 4.03967 3.44337 4.13295 3.44128 4.13545C3.43185 4.14671 3.53109 4.88413 3.58802 5.22594C3.8423 6.75258 4.33471 8.38275 4.94911 9.73201C5.02725 9.90361 5.12467 10.1177 5.16559 10.2078C5.2193 10.326 5.25057 10.3688 5.278 10.3616C5.31283 10.3524 8.16175 8.66031 8.22259 8.61263C8.24126 8.59799 8.04208 7.86702 7.55313 6.15589C6.99352 4.19754 6.84952 3.72054 6.81854 3.72267C6.79735 3.72414 6.02964 3.81661 5.11255 3.92814ZM15.1354 16.23C14.9844 16.4841 14.5842 17.1553 14.246 17.7216C13.9078 18.2878 13.634 18.7537 13.6376 18.7568C13.6619 18.7782 14.1261 18.9999 14.364 19.1037C15.637 19.6593 16.9184 20.0616 18.264 20.3282C18.7166 20.4179 19.4071 20.5262 19.728 20.5579L19.884 20.5733L20.0863 18.8782C20.21 17.8416 20.2799 17.1749 20.2663 17.1622C20.2485 17.1455 15.4613 15.768 15.4211 15.768C15.415 15.768 15.2864 15.9759 15.1354 16.23Z'
        fill={fill}
      />
    </svg>
  )
}

export default Phone
